import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const allowedRoles = ['[ADMIN]', '[USER]'];

function ProtectedRoute({ Component, LoginComponent }) {
  const accessToken = useSelector((state) => state.tokens.accessToken);
  const userRole = useSelector((state) => state.tokens.userRole);

  const [isAuthorized, setIsAuthorized] = useState(
    accessToken !== '' && allowedRoles.includes(userRole)
  );

  useEffect(() => {
    setIsAuthorized(accessToken !== '' && allowedRoles.includes(userRole));
  }, [accessToken, userRole]);

  return isAuthorized ? <Component /> : <LoginComponent />;
}

export default ProtectedRoute;
